class ExtraMeaningBirthstone extends HTMLElement {
  constructor() {
    super();
    this.price = 0;
    /** @type {HTMLElement|null} */
    this.resultsEl = null;
    /** @type {string} */
    this.productId = '';
    /** @type {string} */
    this.productTitle = '';
    /** @type {string} */
    this.productImage = '';
    /** @type {string} */
    this.productValue = '';
  }

  connectedCallback() {
    this.resultsEl = this.closest('extra-new')?.querySelector('.js-extra-new-results') || null;
    this._getProductInfo();
    this._bindEvents();
    this._updatePrice();
    this._updateButtonText();
  }

  _getProductInfo() {
    // Get product title
    const titleEl = this.querySelector('.extra-meaning-birthstone__info-title');
    if (titleEl) {
      this.productTitle = titleEl.dataset.title
    }

    // Get product image
    const imageEl = this.querySelector('.extra-meaning-birthstone__image');
    if (imageEl && imageEl instanceof HTMLImageElement) {
      this.productImage = imageEl.src;
    }

    // Get product value and variant ID from checkbox
    const meaningInput = this.querySelector('.js-extra-meaning');
    if (meaningInput && meaningInput instanceof HTMLInputElement) {
      this.productValue = meaningInput.value;
      this.productId = meaningInput.dataset.variantId || '';
    }
  }

  _bindEvents() {
    const meaningInput = this.querySelector('.js-extra-meaning');
    const card = this.querySelector('.js-meaning-card');
    if (card && meaningInput) {
      card.addEventListener('click', (e) => {
        const target = e.target;
        if (!(target instanceof HTMLElement)) return;
        if (meaningInput instanceof HTMLInputElement) {
          meaningInput.checked = !meaningInput.checked;
          meaningInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        card.classList.toggle('active', meaningInput instanceof HTMLInputElement && meaningInput.checked);
      });
    }
    if (meaningInput) {
      meaningInput.addEventListener('change', () => {
        this._updatePrice();
        this._updateResults();
        // Notify parent for validation
        const parentPersonalizer = this.closest('custom-personalizer');
        if (parentPersonalizer) {
          const event = new CustomEvent('extraMeaningChanged', { bubbles: true });
          parentPersonalizer.dispatchEvent(event);
        }
      });
    }
  }

  _updateResults() {
    if (!this.resultsEl) return;

    const meaningInput = this.querySelector('.js-extra-meaning');
    const isChecked = meaningInput instanceof HTMLInputElement && meaningInput.checked;

    if (isChecked) {
      this._addToResults();
    } else {
      this._removeFromResults();
    }

    // Update button text based on results
    this._updateButtonText();
  }

  _addToResults() {
    if (!this.resultsEl || !this.productValue) return;

    // Remove existing item for this product
    this._removeFromResults();

    // Add new item
    const itemEl = this._createResultItem();
    this.resultsEl.appendChild(itemEl);
  }

  _removeFromResults() {
    if (!this.resultsEl || !this.productValue) return;

    // Remove all items for this product
    const existingItems = this.resultsEl.querySelectorAll(`[data-product-value="${this.productValue}"]`);
    existingItems.forEach(item => item.remove());
  }

  _createResultItem() {
    const itemEl = document.createElement('div');
    itemEl.className = 'extra-new__result-item';
    itemEl.dataset.productValue = this.productValue;

    itemEl.innerHTML = `
      <div class="extra-new__result-item-content">
        <button type="button" class="extra-new__result-item-remove" aria-label="Remove item">
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
            <path d="M0.579979 8.10678C0.271818 7.77631 0.289897 7.25861 0.620359 6.95044L7.20226 0.81271C7.53272 0.504549 8.05043 0.522627 8.35859 0.85309C8.66675 1.18355 8.64868 1.70126 8.31821 2.00942L1.73631 8.14716C1.40585 8.45532 0.88814 8.43724 0.579979 8.10678Z" fill="#3D3D3D"/>
            <path d="M8.09614 8.36925C7.76568 8.67741 7.24797 8.65933 6.93981 8.32887L0.802085 1.74696C0.493924 1.41649 0.512002 0.898786 0.842465 0.590625C1.17293 0.282463 1.69063 0.300542 1.99879 0.631004L8.13652 7.21292C8.44468 7.54338 8.4266 8.06109 8.09614 8.36925Z" fill="#3D3D3D"/>
          </svg>
        </button>
        <div class="extra-new__result-item-image">
          <img src="${this.productImage}" alt="${this.productTitle}" width="32" height="32">
        </div>
        <div class="extra-new__result-item-title">${this.productTitle}</div>
      </div>
    `;

    itemEl.addEventListener('click', () => this._onRemoveItemClick());

    return itemEl;
  }

  _onRemoveItemClick() {
    // Uncheck the checkbox
    const meaningInput = this.querySelector('.js-extra-meaning');
    const card = this.querySelector('.js-meaning-card');
    if (meaningInput instanceof HTMLInputElement) {
      meaningInput.checked = false;
      // Remove active class from card
      if (card) {
        card.classList.remove('active');
      }
      meaningInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  _updateButtonText() {
    if (!this.resultsEl) return;

    // Find the button with class js-button-atc
    const parentPersonalizer = this.closest('custom-personalizer');
    if (!parentPersonalizer) return;
    const buttonAtc = parentPersonalizer.querySelector('.js-button-atc');
    if (!buttonAtc) return;

    const buttonTextEl = buttonAtc.querySelector('.js-button-text');
    if (!buttonTextEl) return;

    // Check if results container has any items
    const hasItems = this.resultsEl.children.length > 0;

    // Update button text based on whether results are empty or have items
    if (hasItems) {
      // Show "Add to cart" text when there are items
      const textData = buttonTextEl instanceof HTMLElement ? buttonTextEl.dataset.text : null;
      if (textData) {
        buttonTextEl.textContent = textData;
      }
    } else {
      // Show "Skip extras & Add to cart" text when no items
      const skipTextData = buttonTextEl instanceof HTMLElement ? buttonTextEl.dataset.textSkip : null;
      if (skipTextData) {
        buttonTextEl.textContent = skipTextData;
      }
    }
  }

  _updatePrice() {
    // Use checked .js-extra-meaning price value
    let total = 0;
    const meaningInput = this.querySelector('.js-extra-meaning');
    if (meaningInput instanceof HTMLInputElement && meaningInput.checked && meaningInput.dataset.price) {
      total += parseInt(meaningInput.dataset.price, 10) || 0;
    }
    this.price = total;
    // Dispatch event to parent custom-personalizer
    const parentPersonalizer = this.closest('custom-personalizer');
    if (parentPersonalizer) {
      const event = new CustomEvent('extraMeaningBirthstonePriceChanged', {
        bubbles: true,
        detail: { price: total }
      });
      parentPersonalizer.dispatchEvent(event);
    }
  }
}

customElements.define('extra-meaning-birthstone', ExtraMeaningBirthstone);
